import { Grid, withWidth, Menu, MenuItem, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Spinner, SpinnerSize, Stack } from "office-ui-fabric-react";
import Logo from "../../../../../assert/images/MxLearn-Logo.png";
import MenuIcon from "@material-ui/icons/Menu";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import PlatformImage from "../assets/landingPage/ResearchBannerImage.png";
import { AppSettingsActions, AuthActions } from "../../../../../modules/redux";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useDispatch } from "react-redux";
import { AuthState } from "../../../../../modules/redux/Auth/reducer";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import researchStyles from "./styles.module.css";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import bannerTextResearch from "../assets/landingPage/bannerTextResearch.png";
const pages = ["Overview", "Capabilities", "Benefits", "Contact Us"];

const ColorButton = styled(Button)(({ theme }) => ({
  fontFamily: "Abadi"
}));

function alertMessageHTML(severity, title, message, props, dispatch) {
  setTimeout(function () {
    props.setDisableError(true);
    dispatch(AuthActions.logout(""));
    props.setShowRequestTrialMessage(false);
  }, 60000);

  return !props.disableError ? (
    <Alert
      severity={severity}
      style={{
        backgroundColor: "#118F7D",
        opacity: 0.7,
        color: "black",
        fontSize: "12px",
        position: "fixed",
        width: "100%",
        bottom: "0"
      }}
      onClose={() => {
        dispatch(AuthActions.logout(""));
      }}
    >
      <AlertTitle>{title}</AlertTitle>
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </Alert>
  ) : (
    <></>
  );
}

export const useStyles = makeStyles(() => ({
  menu: {
    "& .MuiPaper-root": {
      backgroundColor: "#273041"
    }
  }
}));

function OverView(props) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const [value, setValue] = React.useState(0);
  const MENU_ITEMS = {
    HOME: "home",
    BENEFITS: "benefits",
    OFFER: "offer",
    CONTACT: "contact"
  };

  let [width, setWidth] = React.useState(window.innerWidth);

  let updateWidthAndHeight = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  });

  const handleChange = (data) => {
    setValue(data);
    switch (data) {
      case 0:
        props.handleMenuClick(MENU_ITEMS.HOME);
        break;
      case 1:
        props.handleMenuClick(MENU_ITEMS.OFFER);
        break;
      case 2:
        props.handleMenuClick(MENU_ITEMS.BENEFITS);
        break;
      case 3:
        props.handleMenuClick(MENU_ITEMS.CONTACT);
        break;
      default:
        props.handleMenuClick(MENU_ITEMS.HOME);
        break;
    }
  };
  const dispatch = useDispatch();

  const [signInAnchorEl, setSignInAnchorEl] = React.useState(null);
  const signInOpen = Boolean(signInAnchorEl);
  const handleSignInClick = (event) => {
    setSignInAnchorEl(event.currentTarget);
  };
  const handleSignInClose = () => {
    setSignInAnchorEl(null);
  };

  const [msAuthServiceFlag, setMsAuthServiceFlag] = useState(false);
  useEffect(() => {
    if (msAuthServiceFlag) {
      props.onSignIn();
    }
  }, [msAuthServiceFlag]);

  const msSignInService = (service) => {
    setTimeout(2000);
    dispatch(AppSettingsActions.updateAppSettings({ msService: service }));
    setMsAuthServiceFlag(true);
  };

  const bannerText = {
    title: "ManageX Research",
    subTitle: "Accelerating research at cloud speed",
    paragraph:
      "Bring the speed, scale, and security of the cloud directly into your existing workflow without changing what you do or how you do it.",
    available: "NOW AVAILABLE:",
    workloads: "NIST 800-171 Compliant environments for your research workloads"
  };
  const manageXDoText = {
    title: "What can ManageX do for me?",
    list: [
      "Boost your productivity across all research disciplines",
      "Complex architectures deployed with a single click",
      "Efficient & granular cost management with modern governance",
      "Compelling research outcomes that bridge academia and cloud"
    ]
  };

  return (
    <React.Fragment>
      {/* navbar */}
      <AppBar position="fixed" className={researchStyles.mainMenu}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box
              href="#app-bar-with-responsive-menu"
              sx={{
                display: { xs: "none", md: "flex" }
              }}
              className={researchStyles.logo}
            >
              <img src={Logo} alt="Logo" className={researchStyles.menuLogo} />
            </Box>
            {/* Mobile menu */}
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "flex", md: "none" },
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="default"
              >
                <MenuIcon />
              </IconButton>
              <img src={Logo} alt="Logo" height="30px" />
              {/* singn in */}
              <div
                onClick={(e) => {
                  props.setShowRequestTrialMessage(false);
                  handleSignInClick(e);
                }}
              >
                <Menu
                  id="Sign-in Options"
                  anchorEl={signInAnchorEl}
                  open={signInOpen}
                  onClose={handleSignInClose}
                  MenuListProps={{
                    "aria-labelledby": "Sign in details"
                  }}
                  anchorOrigin={{ vertical: "center", horizontal: "center" }}
                  transformOrigin={{ vertical: "top", horizontal: "center" }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      handleSignInClose();
                      msSignInService("us_gov");
                    }}
                  >
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: 14,
                        cursor: "pointer"
                      }}
                    >
                      US Government
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleSignInClose();
                      msSignInService("general");
                    }}
                  >
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: 14,
                        cursor: "pointer"
                      }}
                    >
                      Global Service
                    </Typography>
                  </MenuItem>
                </Menu>
                {props.auth.state === props.AuthState.LOGIN_REQUEST ||
                props.auth.state === props.AuthState.SET_TOKEN ? (
                  <Spinner
                    styles={{ root: { marginTop: "3px", color: "#6b3bf9" } }}
                    size={SpinnerSize.small}
                    label="SIGN IN...."
                    ariaLive="assertive"
                    labelPosition="right"
                  />
                ) : (
                  <Stack horizontal horizontalAlign="end">
                    {" "}
                    <ExitToAppIcon style={{ color: "#000" }} />
                  </Stack>
                )}
              </div>
              {/* dropdown menu */}
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                  flexGrow: 0
                }}
              >
                {pages.map((page, index) => (
                  <MenuItem
                    key={page}
                    onClick={() => {
                      handleChange(index);
                      handleCloseNavMenu();
                    }}
                  >
                    <Typography align="center">{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            {/* Desktop Menu */}
            <Box
              sx={{ marginLeft: "auto", display: { xs: "none", md: "flex" } }}
            >
              {pages.map((page, index) => (
                <ColorButton
                  key={index}
                  sx={{ my: 2, display: "block" }}
                  className={
                    value === index
                      ? researchStyles.active + " " + researchStyles.menuItems
                      : researchStyles.menuItems
                  }
                  onClick={() => {
                    handleChange(index);
                  }}
                >
                  {page}
                </ColorButton>
              ))}
              {/* sign in */}
              {props.auth.state === props.AuthState.LOGIN_REQUEST ||
              props.auth.state === props.AuthState.SET_TOKEN ? (
                <Spinner
                  styles={{ root: { marginTop: "3px", color: "#6b3bf9" } }}
                  size={SpinnerSize.small}
                  ariaLive="assertive"
                  labelPosition="right"
                >
                  <Typography
                    style={{
                      fontWeight: 800,
                      fontSize: 14,
                      color: "#6b3bf9",
                      padding: 20,
                      cursor: "pointer"
                    }}
                  >
                    Sign in...
                  </Typography>
                </Spinner>
              ) : (
                <>
                  <ColorButton
                    onClick={(e) => {
                      props.setShowRequestTrialMessage(false);
                      handleSignInClick(e);
                    }}
                    className={researchStyles.menuItems}
                  >
                    Sign in
                  </ColorButton>
                  <Menu
                    id="Sign-in Options"
                    anchorEl={signInAnchorEl}
                    open={signInOpen}
                    onClose={handleSignInClose}
                    MenuListProps={{
                      "aria-labelledby": "Sign in details"
                    }}
                    anchorOrigin={{
                      vertical: "center",
                      horizontal: "center"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center"
                    }}
                    getContentAnchorEl={null}
                  >
                    <MenuItem
                      onClick={() => {
                        handleSignInClose();
                        msSignInService("us_gov");
                      }}
                    >
                      <Typography
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          cursor: "pointer"
                        }}
                      >
                        US Government
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleSignInClose();
                        msSignInService("general");
                      }}
                    >
                      <Typography
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          cursor: "pointer"
                        }}
                      >
                        Global Service
                      </Typography>
                    </MenuItem>
                  </Menu>
                </>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      {/* banner */}
      <section className={researchStyles.mainBanner}>
        <img
          src={bannerTextResearch}
          alt="banner text research"
          className={researchStyles.bannerText}
        />
        <Container maxWidth="xl">
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item md={6} className={researchStyles.research}>
              <h1>{bannerText.title}</h1>
              <p>{bannerText.subTitle}</p>
              <ColorButton
                variant="contained"
                onClick={() => {
                  props.handleMenuClick("requestTrail");
                }}
                className={researchStyles.bannerBtn}
              >
                Sign Up
              </ColorButton>
              <p>{bannerText.paragraph}</p>
              <h2>{bannerText.available}</h2>
              <p className={researchStyles.workload}>{bannerText.workloads}</p>
            </Grid>
            <Grid item className={researchStyles.bannerimgContainer} md={6}>
              <img
                src={PlatformImage}
                alt="Platform"
                className={researchStyles.bannerImg}
              />
            </Grid>
          </Grid>
        </Container>
      </section>
      {/*what manageX*/}
      <section className={researchStyles.whatIsContainer}>
        <Container className={researchStyles.whatIsTextualWrapper} maxWidth="xl">
          <Grid container spacing={2}>
            <Grid item md={6}>
              <h3 className={researchStyles.sectionTitle}>
                {manageXDoText.title}
              </h3>
              <ul className={researchStyles.whatIsList}>
                {manageXDoText.list.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </Container>
        <div className={researchStyles.dotMainCon}>
          {[...Array(3)].map((x, index) => (
            <ul key={index} className={researchStyles.backgroundDots}>
              {[...Array(8)].map((x, index) => (
                <li key={index} />
              ))}
            </ul>
          ))}
        </div>
      </section>
      {/* alerts */}
      {props.showRequestTrailMessage &&
        alertMessageHTML(
          !props.loginRequestStatus ? "error" : "success",
          !props.loginRequestStatus
            ? "Sign up Error"
            : "Sign up Request Submitted Successfully",
          props.loginErrorMessage,
          props,
          dispatch
        )}
      {props.auth.state === AuthState.LOGIN_ERROR &&
        alertMessageHTML(
          "error",
          "Login Error",
          props.loginErrorMessage,
          props,
          dispatch
        )}
    </React.Fragment>
  );
}

export default withWidth()(OverView);
